module.exports = __webpack_public_path__ + "HBRS.58442730c14acd16c05a1c6f16516ac4.png";